import { HTTP_METHODS } from "constants/CommonConstants";
import { IS_LOADING, TOAST_STATUS } from "utils/constant";

// Define base URLs
const BASE_URLS = {
  AUTH: "auth",
  ADMIN: "auth/dashboard",
  PROFILE: "profile",
  PAGE: "page",
  DESIGNATION: "designation",
  USER: "user",
  STATUS_CATEGORY: "statusCategory",
  EMAIL_TEMPLATE: "emailTemplate",
  TESTIMONIAL: "testimonial",
  ADVERTISEMENT: "advertisement",
  BANNER: "banner",
  STATE: "state",
  CITY: "city",
  GLOBAL: "global",
  VENUE: "venue",
  USER_BANK: "userBank",
  ANCILLARY_SERVICE: "ancillaryService",









};

// Function to create endpoint object
const createEndpoint = (url, method , toastStatus = false) => ({ url, method ,toastStatus });

// Function to generate CRUD endpoints with options
const generateCrudEndpoints = (baseUrl, options , apis) => {
  const endpoints = {};



  if (options.read) {
    endpoints.READ = createEndpoint(`${baseUrl}`, HTTP_METHODS.GET ,TOAST_STATUS.ON);
  }

  if (options.create) {
    endpoints.CREATE = createEndpoint(`${baseUrl}`, HTTP_METHODS.POST ,TOAST_STATUS.ON);
  }

  if (options.update) {
    endpoints.UPDATE = createEndpoint(`${baseUrl}/:id`, HTTP_METHODS.PATCH ,TOAST_STATUS.ON);
  }

  if (options.delete) {
    endpoints.DELETE = createEndpoint(`${baseUrl}/:id`, HTTP_METHODS.DELETE ,TOAST_STATUS.ON);
  }

  if (options.read_one) {
    // Assuming READ_ONE means fetching a single item
    endpoints.READ_ONE = createEndpoint(`${baseUrl}/:id`, HTTP_METHODS.GET ,TOAST_STATUS.OFF);
  }

  if(apis){
    for(let apiKey in apis){
      endpoints[apiKey] = apis[apiKey]

    }
  }

  return endpoints;
};

// API Configuration object with options
export const ApiConfig = {
  AUTH: {
    LOGIN: createEndpoint(`${BASE_URLS.AUTH}/login`, HTTP_METHODS.POST ,TOAST_STATUS.ON),
    REGISTER: createEndpoint(`${BASE_URLS.AUTH}/register`, HTTP_METHODS.POST ,TOAST_STATUS.ON),
    OTP: createEndpoint(`${BASE_URLS.AUTH}/login`, HTTP_METHODS.POST , TOAST_STATUS.ON),
    FORGOT: createEndpoint(`${BASE_URLS.AUTH}/login`, HTTP_METHODS.POST ,TOAST_STATUS.ON),
    CHANGE_PASSWORD: createEndpoint(`${BASE_URLS.AUTH}/change-password`, HTTP_METHODS.POST ,TOAST_STATUS.ON),

  },
  GLOBAL: {
    VENUE_CONFIG: createEndpoint(`${BASE_URLS.GLOBAL}/venue-configuration`, HTTP_METHODS.GET ,TOAST_STATUS.OFF),
    BANK_LIST: createEndpoint(`${BASE_URLS.GLOBAL}/bank-list`, HTTP_METHODS.GET ,TOAST_STATUS.OFF),
    ANC_CONFIG: createEndpoint(`${BASE_URLS.GLOBAL}/anc-configuration`, HTTP_METHODS.GET ,TOAST_STATUS.OFF),


  },
  ADMIN: {
    DASHBOARD: createEndpoint(BASE_URLS.ADMIN, HTTP_METHODS.GET ,TOAST_STATUS.OFF),
  },
  PROFILE: generateCrudEndpoints(`${BASE_URLS.PROFILE}`, {
    read: true,
    read_plural: true,  // Example of using read_plural option for pluralized read URL
    create: true,
    update: true,
    delete: true,
    read_one: false,
  },
  
  {
    CHANGE_PASSWORD: createEndpoint(`${BASE_URLS.PROFILE}/change-password`, HTTP_METHODS.POST),
  })
  ,
  
  PAGE: generateCrudEndpoints(`${BASE_URLS.PAGE}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  }),
  EMAIL_TEMPLATE: generateCrudEndpoints(`${BASE_URLS.EMAIL_TEMPLATE}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  }),
  TESTIMONIAL: generateCrudEndpoints(`${BASE_URLS.TESTIMONIAL}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  }),
  VENUE: generateCrudEndpoints(`${BASE_URLS.VENUE}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  },
  {
    CHANGE_STATUS: createEndpoint(`${BASE_URLS.VENUE}/:id/status`, HTTP_METHODS.PATCH ,TOAST_STATUS.ON ,IS_LOADING.OFF),
  }
  ),
  ANCILLARY_SERVICE: generateCrudEndpoints(`${BASE_URLS.ANCILLARY_SERVICE}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  },
  {
    CHANGE_STATUS: createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/:id/status`, HTTP_METHODS.PATCH ,TOAST_STATUS.ON ,IS_LOADING.OFF),
    DELETE_IMAGE: createEndpoint(`${BASE_URLS.ANCILLARY_SERVICE}/:id/image`, HTTP_METHODS.PATCH ,TOAST_STATUS.ON ,IS_LOADING.ON),

  }
  ),


  
  ADVERTISEMENT: generateCrudEndpoints(`${BASE_URLS.ADVERTISEMENT}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  }),
  BANNER: generateCrudEndpoints(`${BASE_URLS.BANNER}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  }),
  STATE: generateCrudEndpoints(`${BASE_URLS.STATE}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  }),

  CITY: generateCrudEndpoints(`${BASE_URLS.CITY}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  }),
  USER_BANK: generateCrudEndpoints(`${BASE_URLS.USER_BANK}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  },
  {
    CHANGE_STATUS: createEndpoint(`${BASE_URLS.USER_BANK}/:id/status`, HTTP_METHODS.PATCH ,TOAST_STATUS.ON ,IS_LOADING.OFF),
  }
  ),
  USER: generateCrudEndpoints(`${BASE_URLS.USER}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: false,
  },
  {
    USER_GET_BY_ROLES: createEndpoint(`${BASE_URLS.USER}/getByRoles`, HTTP_METHODS.POST),
  }
  ),
  DESIGNATION: generateCrudEndpoints(`${BASE_URLS.DESIGNATION}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: false,
  }),
  STATUS_CATEGORY: generateCrudEndpoints(`${BASE_URLS.STATUS_CATEGORY}`, {
    read: true,
    create: true,
    update: true,
    delete: true,
    read_one: true,
  }),
};


